import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-field.css';

var getClassNameList = classNames.bind(styles);
var UitkFieldMessage = function (props) {
    var className = props.className, message = props.message, id = props.id, type = props.type;
    var cssClassNames = getClassNameList("uitk-field-message", "uitk-field-message-".concat(type), "uitk-".concat(type, "-message"), className);
    return (React.createElement("div", { className: cssClassNames, id: "".concat(id, "-").concat(type) }, message));
};

export { UitkFieldMessage };
